import { render, staticRenderFns } from "./mistakeRedo.vue?vue&type=template&id=250f9d4c&scoped=true&"
import script from "./mistakeRedo.vue?vue&type=script&lang=js&"
export * from "./mistakeRedo.vue?vue&type=script&lang=js&"
import style0 from "./mistakeRedo.vue?vue&type=style&index=0&id=250f9d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f9d4c",
  null
  
)

export default component.exports